import React from "react";

const ItemRequiredByIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4510_22)">
        <rect x="4" y="4.21875" width="16" height="16" rx="4" fill="#FFE0C1" />
      </g>
      <path
        d="M10 13.2188C9.85833 13.2188 9.7395 13.1708 9.6435 13.0747C9.54783 12.9791 9.5 12.8604 9.5 12.7188C9.5 12.5771 9.54783 12.4583 9.6435 12.3622C9.7395 12.2666 9.85833 12.2188 10 12.2188C10.1417 12.2188 10.2605 12.2666 10.3565 12.3622C10.4522 12.4583 10.5 12.5771 10.5 12.7188C10.5 12.8604 10.4522 12.9791 10.3565 13.0747C10.2605 13.1708 10.1417 13.2188 10 13.2188ZM12 13.2188C11.8583 13.2188 11.7397 13.1708 11.644 13.0747C11.548 12.9791 11.5 12.8604 11.5 12.7188C11.5 12.5771 11.548 12.4583 11.644 12.3622C11.7397 12.2666 11.8583 12.2188 12 12.2188C12.1417 12.2188 12.2605 12.2666 12.3565 12.3622C12.4522 12.4583 12.5 12.5771 12.5 12.7188C12.5 12.8604 12.4522 12.9791 12.3565 13.0747C12.2605 13.1708 12.1417 13.2188 12 13.2188ZM14 13.2188C13.8583 13.2188 13.7397 13.1708 13.644 13.0747C13.548 12.9791 13.5 12.8604 13.5 12.7188C13.5 12.5771 13.548 12.4583 13.644 12.3622C13.7397 12.2666 13.8583 12.2188 14 12.2188C14.1417 12.2188 14.2603 12.2666 14.356 12.3622C14.452 12.4583 14.5 12.5771 14.5 12.7188C14.5 12.8604 14.452 12.9791 14.356 13.0747C14.2603 13.1708 14.1417 13.2188 14 13.2188ZM8.5 17.2188C8.225 17.2188 7.9895 17.1209 7.7935 16.9253C7.59783 16.7292 7.5 16.4937 7.5 16.2188V9.21875C7.5 8.94375 7.59783 8.70842 7.7935 8.51275C7.9895 8.31675 8.225 8.21875 8.5 8.21875H9V7.21875H10V8.21875H14V7.21875H15V8.21875H15.5C15.775 8.21875 16.0105 8.31675 16.2065 8.51275C16.4022 8.70842 16.5 8.94375 16.5 9.21875V16.2188C16.5 16.4937 16.4022 16.7292 16.2065 16.9253C16.0105 17.1209 15.775 17.2188 15.5 17.2188H8.5ZM8.5 16.2188H15.5V11.2188H8.5V16.2188ZM8.5 10.2188H15.5V9.21875H8.5V10.2188ZM8.5 10.2188V9.21875V10.2188Z"
        fill="#A15000"
      />
      <defs>
        <filter
          id="filter0_d_4510_22"
          x="0"
          y="0.21875"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4510_22"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4510_22"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ItemRequiredByIcon;
